import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'breadcrumbs',
  template: `
    <li class="breadcrumb-item" style="margin-top: -9px;" *ngFor="let breadcrumb of breadcrumbs; let last = last" [ngClass]="{active: last}">
      <a style="cursor: pointer;color: #20a8d8;" *ngIf="!last" (click)="clickBread(breadcrumb.label.title)">{{breadcrumb.label.title}}</a>
      <span *ngIf="last" [routerLink]="breadcrumb.url">{{breadcrumb.label.title}}</span>
    </li>
    `
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<Object>;
  constructor(private router: Router, private route: ActivatedRoute) { }
  ngOnInit(): void {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      this.breadcrumbs = [];
      let currentRoute = this.route.root,
        url = '';
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary') {
            const routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            this.breadcrumbs.push({
              label: route.snapshot.data,
              url: url
            });
            currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }


  clickBread(title: any) {
    if (title == 'Home') {
      this.router.navigate(['/dashboard']);
    }
    if (title == 'Demand Portal' || title == 'Customer') {
      this.router.navigate(['/demandportal/customer']);
    }
    else if (title == 'Account') {
      this.router.navigate(['/demandportal/customer/account', localStorage.getItem('customerId')]);
    }
    else if (title == 'Projects') {
      this.router.navigate(['/demandportal/customer/account/projects', localStorage.getItem('accountId')]);
    }
    else if (title == 'Subscriptions') {
      this.router.navigate(['/demandportal/customer/account/subscriptions', localStorage.getItem('accountId')]);
    }
    else if (title == 'Users') {
      this.router.navigate(['/demandportal/customer/account/users', localStorage.getItem('accountId')]);
    }
    else if (title == 'Parrot') {
      this.router.navigate(['/parrot']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumb.component.ts